import imguser from '../../../../assets/images/series.png'
import moment from 'moment';

export const ColumnProjectType = (translate,warning,handleEdit,langLocal) => {
    const columns = [
        {
            name: <span className="color_spann">{translate('id')}</span>, sortable: true,
            cell: (row) => (
                <span>{row['id']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('name')}</span>, sortable: true,
            cell: (row) => (
                <div className='div_img_table' >
                    <img className={langLocal=== 'ar'? "margin_left_10":"margin_right_10"} src={imguser} />
                    <span>{row['name']}</span>
                </div>
            )
        },
        {
            name: <span className="color_spann">{translate('type')}</span>, width: "220px",
            cell: (row) => (
                <span>{row['type']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('created_at')}</span>,
            cell: (row) => (
                <span>{moment(row['created_at']).format("YYYY-MM-DD")}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('actions')}</span>,
            cell: (row) => (
                <div>
                    <i className='fa fa-edit icon_edit' onClick={(e)=> handleEdit(e,row)} ></i>
                    <i className='fa fa-trash icon_trash' onClick={() => warning(row)} ></i>
                </div>
            )
        }
    ]
    return {
        columns
    }
}

{/*<OptionsIcon warning={warning} row={row} setopenEdit={setopenEdit} handleEdit={handleEdit} />*/ }